import { Component, input, output } from '@angular/core';
import { FileItemDeletedEvent } from './model/file-item-deleted-event.interface';

@Component({
  selector: 'shared-ui-upload-file-items',
  imports: [],
  templateUrl: './upload-file-items.component.html',
})
export class UploadFileItemsComponent {
  readonly files = input.required<File[]>();

  readonly removeFile = output<FileItemDeletedEvent>();

  protected onClickRemove(file: File, index: number) {
    this.removeFile.emit({ file, index });
  }
}
